import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";
import useToastContext from "@casino/legacyUi/Toast/Context/useToastContext";
import replaceVariables from "./i18n/replaceVariables";

const useToast = () => {
  const { translations } = useAppContext();
  const { showToast: showToastFn } = useToastContext();

  const showToast = (props: Parameters<typeof showToastFn>[0]) => {
    const translation = translations[props.message] ?? props.message;
    const translateValues = props.translateValues ?? {};
    const message = replaceVariables(translation, translateValues);
    showToastFn({ ...props, message });
  };

  return { showToast };
};

export default useToast;
